import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { isLocalStorageAllowed } from 'utils/stringUtils';

export const useFloatingHelpful = () => {
  const location = useLocation();
  const npsVisibility = useSelector(state => state.main.npsVisibility);
  const showAgain = useSelector(state => state.main.showFloatingHelpfulAgain);
  const [showFloatingHelpful, setShowFloatingHelpful] = useState(false);

  useEffect(() => {
    if (isLocalStorageAllowed()) {
      localStorage.removeItem('HIDE_HELPFUL_FLOAT');
    }
    setShowFloatingHelpful(false);
  }, [location]);

  const toggleShowFloatingHelpful = isVisible => {
    const show = showAgain && !npsVisibility.visibility && isVisible;
    if (show) {
      setShowFloatingHelpful(
        isLocalStorageAllowed()
          ? !localStorage.getItem('HIDE_HELPFUL_FLOAT')
          : false,
      );
    }
  };

  const toggleFloatingHelpful = isClose => {
    const isAllowed = isLocalStorageAllowed();
    if (isClose) {
      if (isAllowed) {
        localStorage.setItem('HIDE_HELPFUL_FLOAT', true);
      }
      setShowFloatingHelpful(false);
    } else if (isAllowed && localStorage.getItem('HIDE_HELPFUL_FLOAT')) {
      localStorage.removeItem('HIDE_HELPFUL_FLOAT');
      setShowFloatingHelpful(true);
    } else {
      setShowFloatingHelpful(true);
    }
  };

  return {
    showFloatingHelpful,
    toggleFloatingHelpful,
    toggleShowFloatingHelpful,
  };
};
